import { GridRowModel } from '@mui/x-data-grid';
import { ACL_ACL_ENTRIES_STATUS_TOOLTIP_ENTITIES_BY_PAGE } from 'common/constants/aclEntriesStatusTooltipConfig';
import { AclEntriesStatusTooltipProps } from 'common/types/TypeDefs';
import { AclEntriesPage } from 'features/aclEntries/aclEntriesTypeDefs';

import { TooltipMessageTemplate } from './components/TooltipMessageTemplate';
import { _createStatusTooltipContentList } from './helpers';

export const AclEntriesCommonTooltip = (row?: GridRowModel) => {
    if(!row?.['statusTooltip']) {
        return <></>;
    }
    const statusTooltipProps = row['statusTooltip'] as AclEntriesStatusTooltipProps;
    const currentAclPage = row['currentPage'] as AclEntriesPage;
    const currentAclEntriesStatusTooltipEntityConfig = ACL_ACL_ENTRIES_STATUS_TOOLTIP_ENTITIES_BY_PAGE[currentAclPage] ?? [];

    const statusTooltipContentList = _createStatusTooltipContentList(statusTooltipProps, currentAclEntriesStatusTooltipEntityConfig);

    const inactiveExplanationToRender = statusTooltipContentList
        .filter(item => item.inactive)
        .map((item) => (
            <TooltipMessageTemplate
                key={`inactive-status-message-${item.testId}`}
                message={item?.inactiveReasonMessage ?? ''}
                useDescriptionStyle
                testId={item.inactiveTestId ?? ''}
            />
        ));

    const tooltipDatesInfoToRender = statusTooltipContentList.map((content) => (
        <TooltipMessageTemplate
            key={`status-info-${content.testId}`}
            message={content.message}
            testId={content.testId}
        />
    ));

    return (
        <span>
            {tooltipDatesInfoToRender}
            {inactiveExplanationToRender}
        </span>
    );
};
